import { useTranslation } from 'react-i18next';
import { getInvestorLocale } from '@app/utils/getInvestorLocale';
import { useIsMobile } from '@app/utils/isMobile';
import FilterPopup from './common/filter/FilterPopup';
const NoOpportunities = ({ isInvestment, filters, onFilterChange, }) => {
    const { t } = useTranslation();
    const [isMobile] = useIsMobile();
    const locale = getInvestorLocale();
    const hasFilters = !!Object.keys(filters || {}).length;
    return (<div className="flex flex-col gap-6">
            {onFilterChange && hasFilters && (<div className="flex items-start">
                    <FilterPopup isMobile={isMobile} onFilterChange={onFilterChange} filters={filters} showCreditScore={!isInvestment} showInvestmentStatus={isInvestment}/>
                </div>)}
            <div className="flex flex-col items-center gap-4 px-8 py-16 mx-auto max-w-xl min-w-72 w-full text-center">
                <p className="title-l text-neutral-primary-initial">
                    {hasFilters && t('financing.no_investments.no_results')}
                    {isInvestment && !hasFilters && t('financing.no_investments.no_investments')}
                    {!isInvestment && !hasFilters && t('financing.no_investments.no_opportunities')}
                </p>
                <a href={`https://www.paysera.com/v2/${locale}/legal`} target="_blank" className="text-action-primary-initial body-l" rel="noreferrer">
                    {t('financing.no_investments.legal_info')}
                </a>
            </div>
        </div>);
};
export default NoOpportunities;
